export default __webpack_public_path__ + "static/media/logo_med2lab_sm.260599f6.svg";